import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const todoEntityAdapter: EntityAdapter = {
  entity: "todo",
  searchAutoFocus: false,
};
